import { TimesheetReportType } from './TimesheetReportType';
import isNil from 'lodash/isNil';
import { useMemo } from 'react';
import type { Nullable } from 'types/util/Nullable';

const TIMESHEET_REPORT_INCLUDE_UNPAID_PTO_TYPES = new Set<TimesheetReportType>([
  TimesheetReportType.TIME_OFF_BOTH,
  TimesheetReportType.TIME_OFF_UNPAID,
]);

export function lookupShouldIncludeUnpaidPtoInTotal(
  timesheetReportType: Nullable<TimesheetReportType> = TimesheetReportType.ENTRY_AND_ALL_TIME_OFF
): boolean {
  if (isNil(timesheetReportType)) {
    return false;
  }

  return TIMESHEET_REPORT_INCLUDE_UNPAID_PTO_TYPES.has(timesheetReportType);
}

export function useShouldIncludeUnpaidPtoInTotal(timesheetReportType?: Nullable<TimesheetReportType>): boolean {
  return useMemo(() => lookupShouldIncludeUnpaidPtoInTotal(timesheetReportType), [timesheetReportType]);
}
